<i18n locale="en">
{
  "defaults": {
    "location-select": "Select location",
    "select": "Select an option"
  }
}
</i18n>

<template>
  <PreviewSheet border="primary" class="select-preview" radius="0">
    <div class="flex-col gap-2">
      <div class="flex-row">
        <PreviewTypographyLegacy :text="label" variant="titleSmall" />
        <PreviewTypographyLegacy
          v-if="required"
          color="danger"
          text="*"
          variant="titleSmall"
        />
      </div>
      <PreviewDropDown :placeholder="t('defaults.select')" />
    </div>
  </PreviewSheet>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import PreviewTypographyLegacy from '@/lib/builder/public/preview/legacy/PreviewTypographyLegacy.vue'
import PreviewDropDown from '@/lib/builder/public/preview/PreviewDropDown.vue'
import PreviewSheet from '@/lib/builder/public/preview/PreviewSheet.vue'

interface Props {
  content: Record<string, any>
  /**
   * Override data for out of module rendering contexts
   */
  populatedData?: Record<string, any>
}

const props = defineProps<Props>()

const { t } = useI18n()

const currentBlock = computed(() => {
  return props.populatedData ?? props.content
})

const label = computed(() => {
  return currentBlock.value?.params?.label || t(`defaults.${type.value}`)
})

const required = computed(() => {
  return currentBlock.value?.params?.required
})

const type = computed(() => {
  return currentBlock.value?.type
})
</script>

<style lang="scss" scoped>
.select-preview {
  padding: 12px 40px;
  overflow: visible;
}
</style>
